/* RESPONSIBLE TEAM: team-proactive-support */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';

export default IntercomRoute.extend({
  customReportsService: service(),

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  },
});
